<template>
  <div>
    <b-collapse v-model="collaped">
      <b-row no-gutters class="my-5">
        <b-col cols="2" md="3" lg="4">
          <hr class="border-secondary border-2px" />
        </b-col>
        <b-col cols="8" md="6" lg="4">
          <h6
            class="
              h5
              bg-white
              border border-secondary border-2px
              m-0
              py-2
              px-2 px-md-5
              text-muted text-center
            "
            style="border-radius: 20px"
          >
            シミュレーション終了！
          </h6>
        </b-col>
        <b-col cols="2" md="3" lg="4" class="position-relative">
          <hr class="border-secondary border-2px" />
          <b-img
            :src="require('@/assets/images/icon-track.svg')"
            class="position-absolute"
            style="top: -11px; right: 0"
          ></b-img>
        </b-col>
      </b-row>
      <div class="text-center">
        <b-img :src="require('@/assets/images/icon-aircon.svg')"></b-img>
      </div>
      <p class="mt-5 text-center h3 text-muted">総工事費</p>
      <div class="mt-4 display-4 text-center text-danger font-weight-bold"><small>¥</small>{{ grandTotal.toLocaleString() }}-</div>

      <p class="mt-3 text-center text-muted">※うるさらエアコンは別途追加費用+8,000円を頂いております</p>

      <!-- <b-row class="mt-5" align-h="center">
        <b-col cols="12" md="6" class="">
          <b-button
            variant="warning"
            block
            size="lg"
            class="btn-gd"
            @click="goToPage2"
            >取付を依頼する</b-button
          >
        </b-col>
      </b-row> -->
      <p class="text-center h5 my-4">
        <!-- または -->
      </p>
      <b-row class="mb-5" align-h="center">
        <b-col cols="12" md="6" class="">
          <b-button
            variant="light"
            block
            size="lg"
            class="btn-gd"
            @click="continueSimulation()"
            >別のエアコン工事を追加する</b-button
          >
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      collaped: false,
    };
  },
  watch: {
    maxStep(val, old) {// eslint-disable-line
      this.collaped = val >= 13;
    },
    // total(val, old) {

    // }
  },
  computed: {
    ...mapState({
      maxStep() {
        return this.$store.getters.maxStep;
      },
      grandTotal() {
        return this.$store.getters.grandTotal;
      },
    }),
  },
  methods: {
    reset() {
      this.collaped = false;
    },
    goToPage2() {
      // vuexに見積を保存
      this.doPushPriceDetail();
      this.$router.push({ name: "page2" });
    },
    continueSimulation() {
      // vuexに見積を保存
      this.doPushPriceDetail();
      // step2に巻き戻す
      this.$emit("continueSimulation");
    },
    ...mapActions({
      doPushPriceDetail: "doPushPriceDetail",
    }),
  },
};
</script>